import { createErrorSelector, createLoadingSelector } from '../../utils/reduxUtils';
import {
  GET_PATIENTS,
  GET_PATIENT,
  CREATE_PATIENT,
  EDIT_PATIENT,
  REACTIVATE_PATIENT,
  GET_PATIENT_HISTORY,
} from '../actions';
import { ExercisePerformanceRawDataItem } from '../../types/exercisePerformance';
import {AppStore} from '../store';
import {Report} from '../reducers/patientsReducer';

export const patientsSelector = (tab: string) => (state: any) => state.patients?.[tab];

export const patientsPaginationSelector = (state: any) => state.patients.pagination;

export const patientsLoadingSelector = createLoadingSelector([GET_PATIENTS]);
export const patientsErrorSelector = createErrorSelector([GET_PATIENTS]);

export const currentPatientSelector = (id: string) => (state: any) => state.patients.current?.[id];
export const patientHistorySelector = (id: string) => (state: any) =>
  state.patients.patientHistory?.[id] ?? [];
export const patientHistoryLoadingSelector = createLoadingSelector([GET_PATIENT_HISTORY]);
export const reactivatedPatientSelector = (state: any) => state.patients.reactivatedPatient;

export const patientLoadingSelector = createLoadingSelector([GET_PATIENT]);
export const patientErrorSelector = createErrorSelector([GET_PATIENT]);

export const createPatientErrorSelector = createErrorSelector([CREATE_PATIENT]);
export const editPatientErrorSelector = createErrorSelector([EDIT_PATIENT]);
export const reactivatePatientLoadingSelector = createLoadingSelector([REACTIVATE_PATIENT]);

export const exercisesActiveStatusError = (state: any) => state.patients.exercisesActiveStatusError;
export const assignExercisesSuccessShowModal = (state: any) =>
  state.patients.assignExercisesSuccessShowModal;

export const assignExercisesErrorShowModal = (state: any) =>
  state.patients.assignExercisesErrorShowModal;

export const getCurrentPatient = (state: any) => state.patients.currentPatient;
export const getExercisePerformanceData = (state: any) =>
  state.patients.currentPatient?.exercisePerformanceData as ExercisePerformanceRawDataItem[];

export const getTableState = (state: any) => ({
  tableYScrollPosition: state.patients.tableYScrollPosition,
  tab: state.patients.tab,
});

export const getDefaultMedications = (state: any) => state.patients.defaultMedications;

export const getCurrentReport = (state: AppStore): Report => state.patients.currentReport;

export const getCurrentSchedules = (state: any) => state.patients.schedules;

export const getTotalPatients = (state: any) => [
  state.patients.totalActive,
  state.patients.totalFinished,
];

export const getPatientSteps = (state: AppStore) => state.patients.steps;

export const getPatientAsymmetry = (state: AppStore) => state.patients.asymmetry;
